import { formatCurrency } from '@marine/utils/formatters';
import { cn } from '@/lib/utils';
import type { InventoryEquipment } from '@/modules/inventory/types/boat.types';
import { equipmentTotals } from '@/modules/inventory/utils/equipmentTotals';

interface EquipmentTotalsFooterProps {
  rows: readonly Pick<InventoryEquipment, 'cost' | 'price'>[];
  className?: string;
}

/** #1286 — "28 items · Cost $23,980.00 · Price $0.00" under an equipment list. */
export function EquipmentTotalsFooter({ rows, className }: EquipmentTotalsFooterProps) {
  const totals = equipmentTotals(rows);
  return (
    <p data-testid="equipment-totals" className={cn('text-xs text-muted-foreground tabular-nums', className)}>
      {totals.count} {totals.count === 1 ? 'item' : 'items'} · Cost {formatCurrency(totals.cost)} · Price{' '}
      {formatCurrency(totals.price)}
    </p>
  );
}
